<template>
  <span
    class="small-h3"
    :class="{ hover, active: isActive }"
    :title="isActive ? $t('order.sortStatusLabel', { direction: $t('order.sortDirection' + (inverted ? 'Desc' : 'Asc')) }) : ''"
    @click="$emit('sort', index)"
    @mouseover="hover = true"
    @focus="hover = true"
    @mouseleave="hover = false"
    @blur="hover = false"
  >
    <span :id="id"><slot /></span>
    <button
      class="btn btn-clean btn-icon"
      :title="$t('order.sortButtonLabel', { direction: $t('order.sortDirection' + (!isActive || inverted ? 'Asc' : 'Desc')) })"
      :aria-labelledby="id"
      @focus="hover = true"
      @blur="hover = false"
    >
      <VSvgIcon :name="arrowId" variant="outlined" />
    </button>
  </span>
</template>

<script>
import VSvgIcon from '@/components/UI/VSvgIcon.vue';

export default {
  name: 'SortButton',
  components: { VSvgIcon },

  props: {
    index: {
      type: Number,
      required: true,
    },

    inverted: {
      type: Boolean,
      required: true,
    },

    activeIndex: {
      type: Number,
      required: true,
    },

    id: {
      type: String,
      required: false,
      default: () => Math.random().toString(36).substring(2),
    },
  },

  data() {
    return {
      hover: false,
    };
  },

  computed: {
    isActive() {
      return this.index === this.activeIndex;
    },
    arrowId() {
      const dir = this.isActive && this.inverted ? 'navigation-up' : 'navigation-down';
      return `${dir}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.icon {
  visibility: hidden;
}

.hover,
.active {
  cursor: pointer;

  .icon {
    visibility: visible;
  }
}

.btn-icon {
  padding: 6px 10px 7px;

  .active {
    color: $color-brand;
  }
}
</style>
